import memoize from 'lodash.memoize';
import { adjustAudioMap, getCurrentHighlight } from './wordTracking';
// regex for splitting text into sentences;
const sentenceRegex = /(?:[^ \p{Letter}\u0300-\u0362\d'’:/.,-]|[ .,](?=[^\p{Letter}\u0300-\u0362\d])|[:/](?=[^\d]))+/u
// regex for splitting text into words;
const wordRegex = /(?:[^\p{Letter}\u0300-\u0362\d'’:/.,-]|[.,](?=[^\p{Letter}\u0300-\u0362\d])|[:/](?=[^\d]))+/u

const clickableRegex = /\p{Letter}/u

function isClickable(text){
  return clickableRegex.test(text);
}

export function parsePlainWords(text, ttsMode){
  if (!text) return "";
  const ttsRegex = ttsMode ? wordRegex : sentenceRegex;
  let rawWords = text.split(ttsRegex);
  return rawWords.filter(Boolean);
}

export function parsePlainWordsTTS(text, ttsMode){
  if (!text) return "";
  const ttsRegex = ttsMode ? wordRegex : sentenceRegex;
  return text
    .replace('e.g.', 'forexample')
    .replace('i.e.', 'thatis')
    .split(ttsRegex)
    .map(w => w.trim())
    .filter(Boolean)
}

const wordTemplateRegex = /((?:[^\p{Letter}\u0300-\u0362\d'’:/.,-]|[.,](?=[^\p{Letter}\u0300-\u0362\d])|[:/](?=[^\d]))+)/u;
const sentenceTemplateRegex = /((?:[^ \p{Letter}\u0300-\u0362\d'’:/.,-]|[ .,](?=[^\p{Letter}\u0300-\u0362\d])|[:/](?=[^\d]))+)/u
const linebreakRegex = /\n/gm
const spaceRegex = /( {2,})/gm

function splitTexts(text, ipaText, wordMode, showIpa){
  const regex = wordMode ? wordTemplateRegex : sentenceTemplateRegex
  const texts = text.split(regex);
  if(showIpa){
    return {
      texts: ipaText.split(regex),
      translatingTexts: texts
    }
  }
  return {
    texts,
    translatingTexts: ipaText ? ipaText.split(regex) : texts
  }
}

function isHighlightedWord(markIndex, index, isLastWord, markLastWord){
  return ((markIndex === 0 || markIndex) && (markIndex === index && !isLastWord) || markLastWord);
}

function symbol(word, isIpa){
  return isClickable(word) || !isIpa
}

function removeSpaceInIpa(word, isIpa){
  return (word == ' ' && isIpa) ? '' : word
}


const elementToHtmlString = memoize((element, markIndex, subIndex) => {
  const isHighlighted = isHighlightedWord(markIndex, element.index);
  const classes = `${element.classes} ${isHighlighted ? 'mark' : ''}`
  const content = (isHighlighted && subIndex > -1) ? getHighlightedContent(element.text, subIndex) : element.text
  //console.log(element.text);
  // const content = getHighlightedContent(element.text, subIndex);
  return `<${element.tagName} data-index="${element.index}" class="${classes}">${content}</${element.tagName}>`
});


function getHighlightedContent(text, index){
  const regex = new RegExp(/[!@#$%^&=+{}\[\]<>,.?~\s]/);
  let notLetterChars = 0;
  let lastWords = 0;
  let lastIndex = text.split(' ').findLastIndex(() => true);
  return text.split(' ').map((word, ind) => {
    const isLastWord = ind === lastIndex;
    if(isLastWord){
    }
    if(regex.test(word.trim()) || word.length === 0){
      notLetterChars += 1;
    }
    const markLastWord = isLastWord && index === ind;
    //if(markLastWord){
      //console.log(word);
    //}
    const classes = `${isHighlightedWord(ind,index + notLetterChars, isLastWord, markLastWord) ? 'nested-mark' : ''}`
    if(markLastWord){
      lastWords += 1;
    }
    return `<span class="${classes}">${word}</span>`
  }).join(' ');
}

export const inflateTemplate = (...args) => {
  const [ text, markIndex, wordMode, ipaText, currentTime, audioMap, speed, showIpa ] = args;
  if(!text || text == '') return '';
  const adjustedAudioMap = currentTime && audioMap ? adjustAudioMap(audioMap, speed) : audioMap;
  const subIndex = adjustedAudioMap ? getCurrentHighlight(adjustedAudioMap, currentTime) : null;
  return getTemplateElements(text,ipaText, wordMode, showIpa)
    .map(element => elementToHtmlString(element, markIndex, subIndex))
    .join('')
    .replace(spaceRegex, '<pre>$1</pre>')
    .replace(linebreakRegex, '<br/>');
}

const buildElement = (word, ttsIndex, originalWord, isIpa, classIndex, wordMode) => {
  const oddClass = classIndex % 2 ? 'even' : 'odd';
  const isSymbol = symbol(originalWord, isIpa)
  const element = {
    tagName: 'span',
    index: ttsIndex,
  }
  if (isSymbol){
    element.classes = `pronounceable symbol clickable ${oddClass}`;
    element.text = word
  } else {
    element.classes = `pronounceable non-symbol`;
    element.text = removeSpaceInIpa(originalWord, isIpa);
  }
  return element;
}

function elementExtractingFn(texts, isIpa, wordMode){
  let ttsIndex = 0;
  let classIndex = 0;
  return (elements, word, i) => {
    if (word == '') return elements;
    if (i%2 === 0){
      const originalWord = texts[i];
      const spanElement = buildElement(word, ttsIndex, originalWord, isIpa, classIndex, wordMode);
      ttsIndex += 1;
      if (symbol(originalWord, isIpa)) classIndex += 1;
      elements.push(spanElement)
      return elements;
    }
    elements.push({
      tagName: 'span',
      classes: 'non-symbol',
      index: -1,
      text: word
    })
    return elements;
  }
}

 export const getTemplateElements = (text, ipa, wordMode, showIpa) => {
  if(!text || text == '') return [];
  const { texts, translatingTexts } = splitTexts(text, ipa, wordMode, showIpa);
  const elements = memoize(() => translatingTexts.reduce(elementExtractingFn(texts, ipa, wordMode), []));
  return elements();
 }

 export function deemphasizePunctuation(text){
   return text.replace(/((?:\d\.\d|[^ \p{Letter}\u0300-\u0362':/.,-])+)/gmu, '<span class="non-symbol">$1</span>')
 }
